module.exports = __webpack_public_path__ + "static/media/sales.a9616f31.svg";